module.exports = __webpack_public_path__ + "img/feat_1.f11bc73f.png";